module.exports = __webpack_public_path__ + "img/sire-icon-dark.36bc4bbf.svg";